<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="Chapter103">
<p class="centerImage"><img alt="images" id="img13" src="images/img13.jpg"/></p>
<p class="caption">Lieutenant Jimmy Greening RCN(R) first flew the Fairey Barracuda with 713 Squadron in the summer of 1944, including deck landing practice on HMS <em class="italic">Rajah. Greening</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// HeroesAll_Chapter103.vue?161667e5